import dev from './dev.json';
import staging from './staging.json';
import prod from './prod.json';
import dcx_dev from './dcx_dev.json';
import dcx_staging from './dcx_staging.json';
import dcx_prod from './dcx_prod.json';

export enum Env {
  Dev = 'DEV',
  Staging = 'STAGING',
  Prod = 'PROD',
}

export const dcxConfig = (env: Env) => {
  switch (env) {
    case Env.Prod:
      return dcx_prod;
    case Env.Staging:
      return dcx_staging;
    case Env.Dev:
    default:
      return dcx_dev;
  }
};

export default (env: Env) => {
  switch (env) {
    case Env.Prod:
      return prod;
    case Env.Staging:
      return staging;
    case Env.Dev:
    default:
      return dev;
  }
};
